const techStackList = [
    {
        "name": "Frontend",
        "description":"Proficient in web development fundamentals with focus on JavaScript. Primary framework is React. Currently expanding and applying knowledge of Vue and Angular."
    },
    {
        "name": "Backend",
        "description":"Proficient in server and database fundamentals with focus on Javascript and Python. Primary environment is NodeJS. Currently expanding and applying knowledge of Firebase."
    },
    {
        "name": "Testing",
        "description":"Proficient in testing fundamentals: unit, integration, end to end, and API testing using Jest, Enzyme, Cypress, and Supertest. Currently expanding knowledge on Cypress."
    },
    {
        "name": "Procedural",
        "description":"Proficient in version control and task management with focus on Git Flow and Trello."
    }
]

export default techStackList;